import React, { useState } from 'react';
import { BookIcon, FileTextIcon, VideoIcon, NewspaperIcon } from 'lucide-react';
const Library = () => {
  // Categorías de recursos
  const categories = [{
    id: 'articulos',
    name: 'Artículos',
    icon: <NewspaperIcon className="h-5 w-5" data-id="element-320" />
  }, {
    id: 'libros',
    name: 'Libros',
    icon: <BookIcon className="h-5 w-5" data-id="element-321" />
  }, {
    id: 'videos',
    name: 'Videos',
    icon: <VideoIcon className="h-5 w-5" data-id="element-322" />
  }, {
    id: 'guias',
    name: 'Guías Prácticas',
    icon: <FileTextIcon className="h-5 w-5" data-id="element-323" />
  }];
  // Recursos de ejemplo
  const resources = [{
    id: 1,
    title: 'Reinventando el retiro: más allá del descanso',
    type: 'articulos',
    author: 'María Rodríguez',
    date: '15 de mayo, 2023',
    description: 'Un análisis sobre cómo las nuevas generaciones están transformando el concepto tradicional de retiro en una etapa de reinvención y propósito.',
    link: '#'
  }, {
    id: 2,
    title: 'Comunidades intergeneracionales: el futuro de la vivienda para mayores',
    type: 'articulos',
    author: 'Carlos Méndez',
    date: '3 de junio, 2023',
    description: 'Explorando nuevos modelos de vivienda que promueven la conexión entre diferentes generaciones y combaten la soledad.',
    link: '#'
  }, {
    id: 3,
    title: 'La revolución de la longevidad: Cómo prepararse para una vida más larga',
    type: 'libros',
    author: 'Dra. Ana López',
    date: '2022',
    description: 'Este libro examina las implicaciones personales y sociales de la creciente esperanza de vida y ofrece estrategias para aprovechar al máximo estos años adicionales.',
    link: '#'
  }, {
    id: 4,
    title: 'El retiro con propósito: Guía para descubrir tu siguiente capítulo',
    type: 'libros',
    author: 'Roberto Sánchez',
    date: '2021',
    description: 'Una guía práctica para redefinir el retiro como una etapa de crecimiento, propósito y contribución significativa.',
    link: '#'
  }, {
    id: 5,
    title: 'Historias de reinvención: Cinco personas que transformaron su retiro',
    type: 'videos',
    author: 'Canal Nuevos Comienzos',
    date: '12 de abril, 2023',
    description: 'Documental que presenta las inspiradoras historias de cinco personas que encontraron nuevas pasiones y propósitos en su retiro.',
    link: '#'
  }, {
    id: 6,
    title: 'Planificación financiera para un retiro pleno',
    type: 'videos',
    author: 'Instituto de Finanzas Personales',
    date: '28 de febrero, 2023',
    description: 'Serie de videos educativos sobre cómo planificar las finanzas para disfrutar de un retiro sin preocupaciones económicas.',
    link: '#'
  }, {
    id: 7,
    title: 'Guía para crear tu plan de bienestar integral en el retiro',
    type: 'guias',
    author: 'Fundación Vida Plena',
    date: '2023',
    description: 'Recurso descargable con ejercicios y planificadores para diseñar un plan de bienestar físico, mental y social durante el retiro.',
    link: '#'
  }, {
    id: 8,
    title: 'Manual para emprender después de los 60',
    type: 'guias',
    author: 'Red de Emprendedores Senior',
    date: '2022',
    description: 'Guía paso a paso para quienes desean iniciar un emprendimiento o proyecto social durante su retiro.',
    link: '#'
  }];
  const [activeCategory, setActiveCategory] = useState('todos');
  const [searchTerm, setSearchTerm] = useState('');
  const filteredResources = resources.filter(resource => {
    const matchesCategory = activeCategory === 'todos' || resource.type === activeCategory;
    const matchesSearch = resource.title.toLowerCase().includes(searchTerm.toLowerCase()) || resource.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  return <div className="bg-gray-50 py-12" data-id="element-324">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-325">
        <div className="text-center mb-12" data-id="element-326">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-327">
            Biblioteca de Recursos
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-328">
            Explora nuestra colección de artículos, libros, videos y guías sobre
            el retiro con propósito
          </p>
        </div>
        {/* Filtros y búsqueda */}
        <div className="bg-white rounded-xl shadow-sm p-6 mb-8" data-id="element-329">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-330">
            <div className="flex flex-wrap gap-2" data-id="element-331">
              <button onClick={() => setActiveCategory('todos')} className={`px-4 py-2 rounded-lg text-sm font-medium ${activeCategory === 'todos' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-332">
                Todos
              </button>
              {categories.map(category => <button key={category.id} onClick={() => setActiveCategory(category.id)} className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center ${activeCategory === category.id ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-333">
                  <span className="mr-2" data-id="element-334">{category.icon}</span>
                  {category.name}
                </button>)}
            </div>
            <div className="w-full md:w-auto" data-id="element-335">
              <input type="text" placeholder="Buscar recursos..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" data-id="element-336" />
            </div>
          </div>
        </div>
        {/* Lista de recursos */}
        <div className="grid md:grid-cols-2 gap-6" data-id="element-337">
          {filteredResources.length > 0 ? filteredResources.map(resource => <div key={resource.id} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow" data-id="element-338">
                <div className="flex items-start" data-id="element-339">
                  <div className="mr-4" data-id="element-340">
                    {categories.find(cat => cat.id === resource.type)?.icon && <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center" data-id="element-341">
                        {categories.find(cat => cat.id === resource.type)?.icon}
                      </div>}
                  </div>
                  <div data-id="element-342">
                    <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-343">
                      {resource.title}
                    </h3>
                    <p className="text-sm text-gray-500 mb-3" data-id="element-344">
                      {resource.author} • {resource.date}
                    </p>
                    <p className="text-gray-700 mb-4" data-id="element-345">{resource.description}</p>
                    <a href={resource.link} className="text-blue-600 hover:text-blue-800 font-medium text-sm" data-id="element-346">
                      Ver recurso completo →
                    </a>
                  </div>
                </div>
              </div>) : <div className="col-span-2 bg-white rounded-xl shadow-sm p-8 text-center" data-id="element-347">
              <p className="text-gray-700" data-id="element-348">
                No se encontraron recursos que coincidan con tu búsqueda.
              </p>
            </div>}
        </div>
        {/* Sección de contribución */}
        <div className="mt-12 bg-blue-50 rounded-xl shadow-sm p-8 text-center" data-id="element-349">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-350">
            ¿Tienes un recurso para compartir?
          </h2>
          <p className="text-gray-700 max-w-2xl mx-auto mb-6" data-id="element-351">
            Nos encantaría conocer tus recomendaciones de artículos, libros,
            videos o guías sobre el retiro con propósito. Comparte tus recursos
            favoritos con nuestra comunidad.
          </p>
          <button className="bg-blue-600 text-white hover:bg-blue-700 px-6 py-3 rounded-lg font-medium" data-id="element-352">
            Sugerir un recurso
          </button>
        </div>
      </div>
    </div>;
};
export default Library;